import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme=>({
    contenedorInicioSesion: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundImage: `url(/background/PortadaWebTSE.png)`,
        '@media (max-width: 1200px)' : {
            backgroundImage: `url(/background/Portada.png)`,
        },
        '@media (max-width: 768px)' : {
            display: 'block',
            backgroundImage: 'none',
            height: '0',
            minHeight: '0',
        },
    },
    title : {
        color: `rgb(118, 123, 121)`,
        fontWeight: 'bold',
        fontSize: '2rem',
        fontFamily: 'sans-serif',
        textAlign: 'center',
        marginTop: "auto"
    },
    contenedorDeCaja: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        margin: '0 10% 0 10%'
    },
    contenedorFormulario: {
        paddingTop: '20px',
        background: 'white',
        marginTop: '10px',
        marginBottom: '10px',
        borderRadius: '27px',
        boxShadow:'0px 0px 0px 2px #1e88e5',
    },
}))